// Import CSS
import './styles/main.scss'

// 3rd Party Packages
import SmoothScroll from 'smooth-scroll'

// Modules
import { InitScrollToTop } from './scripts/scroll-to-top';
import { initializeScrollAnimationTrigger } from './scripts/scroll-animations';
import { Tab } from './scripts/tabs';
import { MultiValueSlider } from './scripts/multi-value-slider';
import { InitMobileMenu } from './scripts/mobile-menu';
import { InitDetailsAnimations } from './scripts/details-animations';

document.addEventListener('DOMContentLoaded', function () {
    document.body.classList.remove('no-js');
    document.body.classList.add('js');

    // Init modules
    InitMobileMenu()
    InitScrollToTop()
    initializeScrollAnimationTrigger()
    InitDetailsAnimations()

    const tabs = Array.from(document.getElementsByClassName('js-tabs'))
    if (tabs) {
        tabs.forEach((tab) => {
            new Tab(tab)
        })
    }
    
    const sliders = document.querySelectorAll('.js-slider')

    if (sliders) {
        sliders.forEach((sliderElement) => {
            new MultiValueSlider(sliderElement);
        });
    }

    const mobileSubMenuToggles = document.querySelectorAll('.sub-menu-toggle')

    mobileSubMenuToggles.forEach(button => {
        button.addEventListener('click', (event) => toggleMobileSubMenu(button))
    })

    function toggleMobileSubMenu(button) {
        var subMenu = button.parentNode.nextElementSibling; // Get the next sibling element (the submenu)
        const isActive = subMenu.classList.toggle('active');
        button.setAttribute('aria-expanded', isActive);
    }

    // Init smooth scroll on anchor links
    const scroll = new SmoothScroll('a[href*="#"]', { speed: 100, offset: 80 })  
})

// document.addEventListener('DOMContentLoaded', function () {
//   const compareButtons = document.querySelectorAll('.add-to-compare');
  
//   compareButtons.forEach(button => {
//     button.addEventListener('click', function () {
//       const propertyId = this.getAttribute('data-property-id');
//       togglePropertyInCompare(propertyId, this);
//     });
    
//     const propertyId = button.getAttribute('data-property-id');
//     if (isPropertyInCompare(propertyId)) {
//       button.setAttribute('data-added', 'true');
//     } else {
//       button.setAttribute('data-added', 'false');
//     }
//   });

//   // Initialize the compare count and handle 0 items
//   updateCompareCount();
// });

// const compareLimit = 3;

// function getCompareCookie() {
//   const name = "wordpress_property_compare_list=";
//   const decodedCookie = decodeURIComponent(document.cookie);
//   const cookieArray = decodedCookie.split(';');
//   for (let i = 0; i < cookieArray.length; i++) {
//     let cookie = cookieArray[i].trim();
//     if (cookie.indexOf(name) == 0) {
//       return cookie.substring(name.length, cookie.length).split(',');
//     }
//   }
//   return [];
// }

// function setCompareCookie(compareList) {
//   compareList = compareList.filter(id => id !== "");
//   if (compareList.length > 0) {
//     document.cookie = `wordpress_property_compare_list=${compareList.join(',')};path=/;`;
//   } else {
//     document.cookie = "wordpress_property_compare_list=;path=/;";
//   }
// }

// function isPropertyInCompare(propertyId) {
//   const compareList = getCompareCookie();
//   return compareList.includes(propertyId);
// }

// function togglePropertyInCompare(propertyId, button) {
//   let compareList = getCompareCookie();

//   if (compareList.includes(propertyId)) {
//     compareList = compareList.filter(id => id !== propertyId);
//     setCompareCookie(compareList);
//     button.setAttribute('data-added', 'false');
//     console.log(`Property ${propertyId} removed from compare list.`);
//   } else {
//     if (compareList.length < compareLimit) {
//       compareList.push(propertyId);
//       setCompareCookie(compareList);
//       button.setAttribute('data-added', 'true');
//       publish('propertyAdded', propertyId);
//       console.log(`Property ${propertyId} added to compare list.`);
//     } else {
//       publish('compareLimitReached', compareLimit);
//     }
//   }
  
//   // Update the compare count in the UI
//   updateCompareCount();
// }

// function updateCompareCount() {
//   const compareCountElement = document.querySelector('[data-compare-number]');
//   const compareList = getCompareCookie();
//   const count = compareList.length;

//   if (count === 0) {
//     compareCountElement.textContent = `(0)`;
//     // Optionally hide the element
//     // compareCountElement.parentElement.style.display = 'none';
//   } else {
//     compareCountElement.textContent = `(${count})`;
//     // Optionally show the element if it was hidden
//     // compareCountElement.parentElement.style.display = 'inline';
//   }
// }

// Notification handler
// subscribe('compareLimitReached', function(limit) {
//   alert(`You can't add more than ${limit} properties to the compare list.`);
// });

// subscribe('propertyAdded', function(propertyId) {
//   console.log(`Property ${propertyId} was added to the compare list.`);
// });
  
